import { render, staticRenderFns } from "./agentNewEdit.vue?vue&type=template&id=ddffa5de&scoped=true"
import script from "./agentNewEdit.vue?vue&type=script&lang=js"
export * from "./agentNewEdit.vue?vue&type=script&lang=js"
import style0 from "./agentNewEdit.vue?vue&type=style&index=0&id=ddffa5de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddffa5de",
  null
  
)

export default component.exports